module.exports = __webpack_public_path__ + "static/media/more.bd3012dc.svg";